// Collapsed sticky CTA button that receives the tooltip nudge.
export enum STICKY_CTA_NUDGE_TARGET {
    shareEmail = 'shareEmail',
    buy = 'buy',
}
